// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__3PAMU","list":"PatternAutocomplete_list__3fY7h"};